<template>
  <div class="surveyM">
    <div class="swiper">
      <el-carousel
        height="100%"
        @change="changeSwiper"
        indicator-position="none"
        :autoplay="false"
      >
        <div class="prev">
          <img class="prevPic" src="../assets/img/arrow-l@2x.png" alt="" />
        </div>
        <div class="next">
          <img class="prevPic" src="../assets/img/arrow-right@2x.png" alt="" />
        </div>
        <!-- <div class="currentMaterial">
          当前拌和：改性SMA-13
        </div> -->
        <div class="legend">
          <span class="yellow"
            ><span class="miniDot yellowDot"></span> 计量波动(%)</span
          ><span><span class="miniDot"></span> 实际重量(kg)</span>
        </div>
        <el-carousel-item v-for="item in swiperList" :key="item.id">
          <div class="currentMaterial">
            <span>当前拌和：{{ item.name ? item.name : "-/-" }}</span>
          </div>
          <div class="swiperCon">
            <!-- <div class="write"></div> -->
            <div class="aggregate" v-if="type == 'lq'">
              <el-row>
                <el-col
                  :span="2"
                  v-for="items in item.powder"
                  :key="items.storeInfo+'a'"
                >
                  <div class="aggregateY">{{ items.offset}}</div>
                  <div class="aggregateB">{{ items.weight}}</div>
                  <div class="aggregateN">{{ items.storeInfo }}</div>
                </el-col>
                <el-col
                  :span="2"
                  v-if="2 - item.powder.length > 0"
                  v-for="(itemes, i) in 2 - item.powder.length"
                  :key="i+'a'"
                >
                  <div class="aggregateY">/</div>
                  <div class="aggregateB">/</div>
                  <div class="aggregateN">
                    矿粉{{ item.powder.length + 1 + i }}
                  </div>
                </el-col>
                <el-col :span="1" class="mar">
                  <div class="aggregateW">""</div>
                </el-col>
                <el-col
                  :span="2"
                  class="mar"
                  v-for="itemes in item.aggregates"
                  :key="itemes.storeInfo+'b'"
                >
                  <div class="aggregateY">{{ itemes.offset}}</div>
                  <div class="aggregateB">{{ itemes.weight}}</div>
                  <div class="aggregateN">{{ itemes.storeInfo }}</div>
                </el-col>
                <el-col
                  :span="2"
                  class="mar"
                  v-if="6 - item.aggregates.length > 0"
                  v-for="(itemes, i) in 6 - item.aggregates.length"
                  :key="i+'b'"
                >
                  <div class="aggregateY">/</div>
                  <div class="aggregateB">/</div>
                  <div class="aggregateN">
                    {{ item.aggregates.length + 1 + i }}#料
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="aggregateW">""</div>
                </el-col>
                <el-col
                  :span="2"
                  class="ali"
                  v-for="itemas in item.asphalt"
                  :key="itemas.storeInfo+'c'"
                >
                  <div class="aggregateY">{{ itemas.offset}}</div>
                  <div class="aggregateB">{{ itemas.weight}}</div>
                  <div class="aggregateN">{{ itemas.storeInfo }}</div>
                </el-col>
                <el-col
                  :span="2"
                  class="ali"
                  v-if="1 - item.asphalt.length > 0"
                  v-for="(itemes, i) in 1 - item.asphalt.length"
                  :key="i+'c'"
                >
                  <div class="aggregateY">/</div>
                  <div class="aggregateB">/</div>
                  <div class="aggregateN">沥青</div>
                </el-col>
              </el-row>
            </div>
            <div class="aggregateSW" v-else>
              <el-row>
                <el-col
                  :span="2"
                  v-for="items in item.powder"
                  :key="items.storeInfo+'d'"
                  class="mar"
                >
                  <div class="aggregateY">{{ items.offset>0? items.offset:''}}</div>
                  <div class="aggregateB">{{ items.weight>0? items.weight:''}}</div>
                  <div class="aggregateN">{{ items.storeInfo }}</div>
                </el-col>
                <el-col
                  :span="2"
                  v-if="6 - item.powder.length > 0"
                  v-for="(itemes, i) in 6 - item.powder.length"
                  :key="i+'d'"
                  class="mar"
                >
                  <div class="aggregateY"></div>
                  <div class="aggregateB"></div>
                  <div class="aggregateN">
                     {{ item.powder.length + 1 + i }}#料
                  </div>
                </el-col>
                <el-col :span="2" class="mare">
                  <div class="aggregateY">{{ item.aggregates[0] && item.aggregates[0].offset> 0?item.aggregates[0].offset:'' }}</div>
                  <div class="aggregateB">{{ item.aggregates[0] && item.aggregates[0].weight >0?item.aggregates[0].weight:'' }}</div>
                  <div class="aggregateN">水泥</div>
                </el-col>
                <el-col :span="2" class="mart">
                  <div class="aggregateY">{{ item.asphalt[0] && item.asphalt[0].offset> 0 ?item.asphalt[0].offset:'' }}</div>
                  <div class="aggregateB">{{ item.asphalt[0] && item.asphalt[0].weight> 0?item.asphalt[0].weight:'' }}</div>
                  <div class="aggregateN">水</div>
                </el-col>
              </el-row>
            </div>
            <img class="mixPic" :src="mixPic" alt="" />
            <div class="currentInfo" v-if="type == 'lq'">
              <div>
                出料时间: <span>{{ item.time ? item.time : "-/-" }}</span>
              </div>
              <div>
                出料温度: <span>{{ item.temp ? item.temp.toFixed(2)+' °C' : "-/-" }}</span>
              </div>
              <div>
                拌和周期: <span>{{ item.cycle ? item.cycle+' 秒' : "-/-" }}</span>
              </div>
            </div>
            <div class="currentInfoSW" v-else>
              <div>出料时间: <span>{{ item.time ? item.time : "-/-" }}</span></div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="frontInfo">
      <div class="cumulativeInfo">
        <div class="frontPic">
          <div  class="cumulativeRotate"></div>
          <img src="../assets/gif/pave.gif" alt="" />
        </div>
        <div class="currentMaterial">当日累计摊铺</div>
        <div v-if="type == 'lq'">
          <div class="layer" :class="num == 1?'':'height80'" v-if='this.paveCurrentDay.up'>
            上面层 : <span>{{this.paveCurrentDay.up}}</span>
          </div>
          <div class="layer" :class="num == 1?'':'height80'" v-if='this.paveCurrentDay.middle'>
            中面层 : <span>{{this.paveCurrentDay.middle}}</span>
          </div>
          <div class="layer" :class="num == 1?'':'height80'" v-if='this.paveCurrentDay.down'>
            下面层 : <span>{{this.paveCurrentDay.down}}</span>
          </div>
        </div>
        <div v-if="type == 'sw'">
          <div class="layer" :class="num == 1?'':'height80'" v-if='this.paveCurrentDay.up'>
            上基层 : <span>{{this.paveCurrentDay.up}}</span>
          </div>
          <div class="layer" :class="num == 1?'':'height80'" v-if='this.paveCurrentDay.middle'>
            下基层 : <span>{{this.paveCurrentDay.middle}}</span>
          </div>
          <div class="layer" :class="num == 1?'':'height80'" v-if='this.paveCurrentDay.down'>
            底基层 : <span>{{this.paveCurrentDay.down}}</span>
          </div>
        </div>
      </div>
      <div class="realTimeInfo">
        <div class="realTimePic">
          <img class="realTimeRotate" src="../assets/img/111.png" alt="" />
        </div>
        <div class="currentMaterial2">实时信息</div>
        <div class="realTimeCon">
          <el-row>
            <el-col :span="8">
              <div class="overWidth">
                <img
                  class="realTimePrefix"
                  src="../assets/img/arrow-left@2x.png"
                  alt=""
                />&nbsp;风速 : <span>{{this.frontInfo.windSpped!=0?this.frontInfo.windSpped+'km/h':'-/-'}}</span>
              </div>
              <!-- {{this.frontInfo.windSpped?this.frontInfo.windSpped+'km/h':'-/-'}} -->
              <div class="pre">
                <div class="Prefix">摊铺</div>
                <div class="someInfo">
                  <div v-if="type == 'lq'">温度 : <span>{{this.paveInfo.temp?this.paveInfo.temp+'°C':'-/-'}}</span></div>
                  <div :class="type == 'sw' ? 'swMargin' : ''">
                    速度 : <span>{{this.paveInfo.speed?this.paveInfo.speed+'m/min':'-/-'}}</span>
                  </div>
                  <div v-if="type == 'lq'">温度离析 : <span v-if="this.paveInfo.temp!=0">{{this.paveInfo.tempSeg==0?'无离析':this.paveInfo.tempSeg+'°C'}}</span><span v-else>-/-</span></div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div>
                <img
                  class="realTimePrefix"
                  src="../assets/img/icon-temperature@2x.png"
                  alt=""
                />&nbsp;温度 : <span>{{this.frontInfo.temp!=0?this.frontInfo.temp+'°C':'-/-'}}</span>
              </div>
              <!-- {{this.frontInfo.temp!=0?this.frontInfo.temp+'°C':'-/-'}} -->
              <div class="pre">
                <div class="Prefix">钢轮</div>
                <div class="someInfo">
                  <div v-if="type == 'lq'">温度 : <span>{{this.steelInfo.temp?this.steelInfo.temp+'°C':'-/-'}}</span></div>
                  <div :class="type == 'sw' ? 'swMargin' : ''">
                    速度 : <span>{{this.steelInfo.speed?this.steelInfo.speed+'km/h':'-/-'}}</span>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div>
                <img
                  class="realTimePrefix"
                  src="../assets/img/icon-humidity@2x.png"
                  alt=""
                />&nbsp;湿度 : <span>{{this.frontInfo.humidity!=0?this.frontInfo.humidity+'%':'-/-'}}</span>
              </div>
              <div class="pre">
                <div class="Prefix">胶轮</div>
                <div class="someInfo">
                  <div v-if="type == 'lq'">温度 : <span>{{this.rubberInfo.temp?this.rubberInfo.temp+'°C':'-/-'}}</span></div>
                  <div :class="type == 'sw' ? 'swMargin' : ''">
                    速度 : <span>{{this.rubberInfo.speed?this.rubberInfo.speed+'km/h':'-/-'}}</span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  getMixplant,
  // getKeyLabellq,
  getRealTimeOutput,
  // getMixplantsw,
  // getKeyLabelsw,
  // getRealTimeOutputsw,
  getCurrentTime,
  getFrontWork,
  getTempWind,
  getInitScreenData
} from "@/api/api";
export default {
  props: {
    type: "",
  },
  data() {
    return {
      currentDate: "",
      currentTime: "",
      mixplantId: "",
      mixtureId: "",
      isFirst: true,
      mixArr:[],
      swiperList: [
        {
          id: 1,
          name: "",
          powder: [],
          aggregates: [],
          asphalt: [],
          time: "",
          temp: "",
          cycle: "",
        }
      ],
      frontInfo:{
        windSpped:"",
        temp:"",
        humidity:""
      },
      paveInfo:{
        temp:"",
        speed:"",
        tempSeg:"",
      },
      steelInfo:{
        temp:"",
        speed:""
      },
      rubberInfo:{
        temp:"",
        speed:""
      },
      paveCurrentDay:{
        up:"",
        middle:"",
        down:""
      },
      num:0,
      mixPic: require("../assets/img/asphaltSketch@2x.png"),
    };
  },
  created() {
    this.dataRefreh();
  },
  mounted() {
    const timeMachine = getCurrentTime();
    this.currentDate = timeMachine.split(" ")[0];
    this.currentTime = timeMachine.split(" ")[1];
    if (this.type == "lq") {
      this.mixPic = require("../assets/img/asphaltSketch@2x.png");
    } else {
      this.mixPic = require("../assets/img/WaterStabilitySketch@2x.png");
    }
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    // 定时刷新数据函数
    dataRefreh() {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return;
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        this.getmixplant();
        this.getTW();
        this.getFrontWorkInfo()
      }, 30000);
    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId); //清除计时器
      this.intervalId = null; //设置为null
    },
    // 获取当前时间
    NumberFix(val) {
      // const dt = new Date();
      const y = val.getFullYear();
      const m = (val.getMonth() + 1).toString().padStart(2, "0");
      const d = val.getDate().toString().padStart(2, "0");
      const h = val.getHours().toString().padStart(2, "0");
      const mi = val.getMinutes().toString().padStart(2, "0");
      const s = val.getSeconds().toString().padStart(2, "0");
      return `${y}-${m}-${d} ${h}:${mi}:${s}`;
    },
    // 获取拌合楼
    async getmixplant() {
      let req = {
        // id: 262,
        id: this.sectionId,
        timeRange: -30,
      };
      const mpDataLQ = await getMixplant(this.type, req);
      let mixList = mpDataLQ.data;
      if(mixList.length > 0) {

      }
      // 判断是否触发过changeSwiper
      let mixplantName = ''
      if (this.isFirst == true) {
        if(mpDataLQ.data.length>0) {
          this.mixplantId = mpDataLQ.data[0].mixplant.id;
          mixplantName = mpDataLQ.data[0].mixplant.name +'-'+ mpDataLQ.data[0].mixplant.no
        }else {
           this.mixplantId = ''
           mixplantName = ''
        }
        this.$store.commit("updataMixplantId", this.mixplantId);
        this.$store.commit( "updataMixplantName",mixplantName);
        if (mpDataLQ.data.length>0&&mpDataLQ.data[0].mixture) {
          this.mixtureId = mpDataLQ.data[0].mixture.id;
        }
      }
      this.mixArr = mixList
      // this.swiperList = [];
      // mixList.forEach((item, i) => {
      //   // if(item.mixture) {
      //   this.swiperList.push({
      //     id: item.mixplant.id,
      //     mixplantName: item.mixplant.name,
      //     mixtureId: item.mixture ? item.mixture.id : "",
      //     name: item.mixture ? item.mixture.name : "",
      //     powder: [],
      //     aggregates: [],
      //     asphalt: [],
      //     time: "",
      //     temp: "",
      //     cycle: "",
      //   });
      //   // }
      // });
      this.getRealTimeOutputs();
    },
    // 获取拌合楼拌和原料
    async getRealTimeOutputs() {
      let timestamp = new Date().getTime();
      timestamp = timestamp + (1 * 60 * 60 * 1000) / 2;
      var dateAfter = new Date(timestamp);
      var dateBefore = new Date();
      let endDateTime = this.NumberFix(dateAfter);
      let startDateTime = this.NumberFix(dateBefore);
      // if (this.type == "lq") {
      let req = {
        endDateTime: endDateTime,
        mixplantId: this.mixplantId,
        mixtureId: this.mixtureId,
        sectionId: this.seIds,
        startDateTime: startDateTime,
        workAreaId: this.sectionId,
      };
      const rtoDataLQ = await getRealTimeOutput(this.type, req);
     this.swiperList = [];
     this.mixArr.forEach((item, i) => {
        // if(item.mixture) {
        this.swiperList.push({
          id: item.mixplant.id,
          mixplantName: item.mixplant.name,
          mixtureId: item.mixture ? item.mixture.id : "",
          name: item.mixture ?item.mixture.type?item.mixture.type.typeName:"": "",
          powder: [],
          aggregates: [],
          asphalt: [],
          time: "",
          temp: "",
          cycle: "",
        });
        // }
      });
     console.log(this.mixtureId)
      if(this.mixtureId) {
         if (this.type == "lq") {
        this.swiperList.forEach((item) => {
          item.time = rtoDataLQ.data.first
            ? rtoDataLQ.data.first.split(" ")[1]
            : 0;
          item.temp = rtoDataLQ.data.temp;
          item.cycle = rtoDataLQ.data.mixperiod;
          item.powder = rtoDataLQ.data.second.filter(
            (item) => item.storeInfo.indexOf("粉") >= 0
          );
          item.aggregates = rtoDataLQ.data.second.filter(
            (item) => item.storeInfo.indexOf("料") >= 0
          );
          // let aggregates = []
          // if(item.aggregates.length < 6) {
          //   for(var i=0; i<6; i++) {
          //     for(var j=0; j<item.aggregates.length; j++) {
          //       if(item.aggregates[j].storeInfo.indexOf(i+1) >= 0) {
          //         aggregates[i] = item.aggregates[j]
          //       }else {
          //         aggregates[i] = {}
          //       }
          //     }
          //   }
          //   item.aggregates = aggregates
          // }

          // console.log(item.aggregates)
          item.asphalt = rtoDataLQ.data.second.filter(
            (item) => item.storeInfo.indexOf("沥") >= 0
          );
        });
      } else {
        rtoDataLQ.data.second.forEach(item => {
          if(item.storeInfo.indexOf("添") >= 0) {
            item.storeInfo = item.storeInfo.charAt(0) + item.storeInfo.charAt(item.storeInfo.length -1)
          }
        })
        this.swiperList.forEach((item) => {
          item.time = rtoDataLQ.data.first
            ? rtoDataLQ.data.first.split(" ")[1]
            : 0;
          item.temp = rtoDataLQ.data.temp;
          item.cycle = rtoDataLQ.data.mixperiod;
          item.powder = rtoDataLQ.data.three.filter(
            (item) => item.storeInfo.indexOf("料") >= 0 || item.storeInfo.indexOf("添") >= 0
          );
          item.aggregates = rtoDataLQ.data.three.filter(
            (item) => item.storeInfo.indexOf("水泥") >= 0
          );
          //      let aggregates = []
          // if(item.aggregates.length < 6) {
          //   for(var i=0; i<6; i++) {
          //     for(var j=0; j<item.aggregates.length; j++) {
          //       if(item.aggregates[j].storeInfo.indexOf(i+1) >= 0) {
          //         aggregates[i] = item.aggregates[j]
          //       }else {
          //         aggregates[i] = {}
          //       }
          //     }
          //   }
          //   item.aggregates = aggregates
          // }
          item.asphalt = rtoDataLQ.data.three.filter(
            (item) => item.storeInfo.indexOf("水") >= 0 && item.storeInfo.indexOf("水泥") == -1
          );
        });
         console.log(this.swiperList)
      }
      }else {

        if (this.type == "lq") {
        this.swiperList.forEach((item) => {
          item.time = 0;
          item.temp = 0;
          item.cycle = 0;
          item.powder =[]
          item.aggregates = []
          item.asphalt = []
        });
      } else {

        // rtoDataLQ.data.second.forEach(item => {
        //   if(item.storeInfo.indexOf("添") >= 0) {
        //     item.storeInfo = item.storeInfo.charAt(0) + item.storeInfo.charAt(item.storeInfo.length -1)
        //   }

        // })
        this.swiperList.forEach((item) => {
          item.time = 0;
          // item.temp = rtoDataLQ.data.temp;
          // item.cycle = rtoDataLQ.data.mixperiod;
          item.powder = []
          item.aggregates = []
          item.asphalt = []
        });
      }
      }
      console.log(this.swiperList)
    },
    // swiper change
    changeSwiper(i) {
      this.isFirst = false;
      this.mixplantId = this.swiperList[i].id;
      this.$store.commit("updataMixplantName", this.swiperList[i].mixplantName);
      this.$store.commit("updataMixplantId", this.mixplantId);
      this.mixtureId = this.swiperList[i].mixtureId;
      this.getRealTimeOutputs();
    },
    // 获取温度风速
    async getTW() {
      // 旧环境监测
      // let req = {
      //   sectionId: this.sectionId,
      //   workAreaId: this.workAreaId
      // }
      //  const twDataLQ = await getTempWind(req);
      // this.frontInfo={
      //   windSpped:twDataLQ.data[0],
      //   temp:twDataLQ.data[1],
      //   humidity:twDataLQ.data[2]
      // }
       // 新环境监测
      let req = {
        engineeringConfigId:this.sectionId
        // engineeringConfigId: 1,
      };
      const ertData = await getInitScreenData(req);
      if (ertData.status == 200) {
        console.log(ertData)
        console.log(ertData.data)
        console.log(ertData.data.resultData)
          this.frontInfo={
          windSpped:Number(ertData.data.resultData.windSpeed).toFixed(0),
          temp:Number(ertData.data.resultData.envTemperature).toFixed(0),
          humidity:Number(ertData.data.resultData.envHumidity).toFixed(0)
        }
        console.log('frontInfo',this.frontInfo)
      }
    },
    // 获取前场实时信息
    async getFrontWorkInfo() {
      let timestamp = new Date().getTime();
      timestamp = timestamp - 1000*60*60*5; //5h
      var dateAfter = new Date(timestamp);
      var dateBefore = new Date();
      let endDateTime = this.NumberFix(dateAfter);
      let startDateTime = this.NumberFix(dateBefore);
      let req = {
        endDateTime: startDateTime,
        materialType: this.type,
        sectionId: this.seIds,
        startDateTime: endDateTime,
        workAreaId: this.sectionId
      }
      const fwiDataLQ = await getFrontWork(this.type, req);
      // 当日累计摊铺
      if(fwiDataLQ.data.countMileByLayer.layers!=null ) {
          if(this.type == 'lq') {
          this.paveCurrentDay ={
             up:fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="上面层")[0] && fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="上面层")[0].value > 0?fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="上面层")[0].value+"km （"+fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="上面层")[0].plug+"）":"",
             middle:fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="中面层")[0] && fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="中面层")[0].value > 0?fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="中面层")[0].value+"km （"+fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="中面层")[0].plug+"）":"",
             down:fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="下面层")[0] && fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="下面层")[0].value > 0?fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="下面层")[0].value+"km （"+fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="下面层")[0].plug+"）":""
          }
        }else {
          this.paveCurrentDay ={
            up:fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="上基层")[0] && fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="上基层")[0].value > 0?fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="上基层")[0].value+"km （"+fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="上基层")[0].plug+"）":"",
            middle:fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="下基层")[0] && fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="下基层")[0].value > 0?fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="下基层")[0].value+"km （"+fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="下基层")[0].plug+"）":"",
            down:fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="底基层")[0] && fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="底基层")[0].value >0?fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="底基层")[0].value+"km （"+fwiDataLQ.data.countMileByLayer.layers.filter(item=>item.name=="底基层")[0].plug+"）":""
      }
      let layer = []
      fwiDataLQ.data.countMileByLayer.layers.map(item => {
        if(item.value>0) {
          layer.push(item)

        }
      })
      console.log(layer)
      this.num = layer.length >1 ? 1:0
        }
      }else {
          this.paveCurrentDay ={
          up:"",
          middle:"",
          down:""
        }
      }

      console.log(fwiDataLQ)
      // 摊铺机数据均值
      this.paveInfo={
        temp:fwiDataLQ.data.paverAvgInfo.temp,
        speed:fwiDataLQ.data.paverAvgInfo.speed,
        tempSeg:fwiDataLQ.data.paverAvgInfo.tempSeg,
      }
      // 钢轮数据均值
      let steelTotal = fwiDataLQ.data.rollerAvgInfo.filter(item=>item.typeName.indexOf('钢')>=0)
      let tempS = 0
      let speedS = 0
      steelTotal.forEach(item=>
        {
          tempS += Number(item.temp),
          speedS += item.speed
        }
      )
      console.log('steelTotal',steelTotal)
      console.log('tempS',tempS)
      this.steelInfo={
        temp:tempS/steelTotal.length,
        speed:(speedS/steelTotal.length).toFixed(2)
      }
      // 胶轮数据均值
       let rubberTotal = fwiDataLQ.data.rollerAvgInfo.filter((item)=>item.typeName.indexOf('胶')>=0)
      let tempR = ''
      let speedR = ''
      rubberTotal.forEach(item=>
        {
          tempR += item.temp,
          speedR += item.speed
        }
      )
      this.rubberInfo={
        temp:tempR/steelTotal.length,
        speed:speedR/steelTotal.length
      }
  },

  },
  computed: mapState(["engineerId", "sectionId", "workAreaId","seIds"]),
  watch: {
    engineerId(curVal, oldVal) {
      this.isFirst = true
    },
    sectionId(curVal, oldVal) {
      // this.getmixplant();
      // this.getFrontWorkInfo()
      // this.getTW()
    },
    workAreaId(curVal, oldVal) {
      this.getmixplant();
      this.getFrontWorkInfo()
      this.getTW()
    },
  },
};
</script>
<style lang="less" scoped>
.surveyM {
  height: 100%;
  width: 100%;
  position: absolute;
  .swiper {
    float: left;
    width: 750px;
    height: 100%;
    background-image: url(../assets/img/indication-frame@2x.png);
    background-size: 100% 100%;
    /deep/ .el-carousel__arrow--left {
      color: rgba(255, 255, 255, 0);
      background: rgba(255, 255, 255, 0);
    }
    /deep/ .el-carousel__arrow--right {
      color: rgba(255, 255, 255, 0);
      background: rgba(255, 255, 255, 0);
    }
    .el-carousel {
      height: 100%;
    }
    .el-carousel__item h3 {
      color: #475669;
      font-size: 18px;
      opacity: 0.75;
      line-height: 300px;
      margin: 0;
    }
    .swiperCon {
      width: 80%;
      height: 100%;
      margin: 0 auto;
      .write {
        width: 100%;
        height: 10%;
      }
      .mar {
        margin-left: 6px !important;
      }
      .ali {
        margin-left: 26px !important;
      }
      .aggregate {
        width: 100%;
        height: 30%;
        .el-row {
          .el-col-1 {
            width: 5%;
            margin-left: 4px;
          }
          .el-col-2 {
            width: 8%;
            margin-left: 2px;
            font-size: 12px !important;
          }
          .el-col-2,
          .el-col-4 {
            height: 100%;
            line-height: 24px;
            text-align: center;
            .aggregateY {
              margin-top: 26px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #e0e0e0;
              height: 18px;
            }
            .aggregateB {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #44f8ff;
              height: 18px;
            }
            .aggregateN {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
            }
            .aggregateW {
              color: rgba(255, 255, 255, 0);
            }
          }
        }
      }
      .aggregateSW {
        width: 100%;
        height: 30%;
        .mar {
          margin-left: 2px !important;
        }
        .mare {
          margin-left: 22px !important;
        }
        .mart {
          margin-left: 8px !important;
        }
        .el-row {
          margin-left: 10px;
          .el-col-1 {
            width: 5%;
            margin-left: 4px;
          }
          .el-col-2 {
            width: 9%;
            // margin-left: 2px;
          }
          .el-col-2,
          .el-col-4 {
            height: 100%;
            line-height: 24px;
            text-align: center;
            .aggregateY {
              margin-top: 26px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #fff721;
              height: 18px;
            }
            .aggregateB {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #44f8ff;
              height: 18px;
            }
            .aggregateN {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
            }
            .aggregateW {
              color: rgba(255, 255, 255, 0);
            }
          }
        }
      }
      .mixPic {
        width: 98%;
        height: 58%;
        margin-left: 2%;
      }
      .currentInfo {
        position: absolute;
        bottom: 5px;
        right: 5px;
        text-align: left;
        padding-left: 10px;
        padding-top: 8px;
        line-height: 22px;
        background-image: url(../assets/img/asphalt-messagebox@2x.png);
        background-size: 100% 100%;
        width: 155px;
        height: 73px;
        div {
          font-size: 12px;
          font-family: Microsoft YaHei;
          color: #ffffff;
          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            color: #fff721;
          }
        }
      }
      .currentInfoSW {
        position: absolute;
        top: 10px;
        right: 15px;
        text-align: center;
        line-height: 30px;
        background-image: url(../assets/img/time-messagebox@2x.png);
        background-size: 100% 100%;
        width: 158px;
        height: 30px;
        div {
          font-size: 14px;
          font-family: Microsoft YaHei;
          color: #ffffff;
          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            color: #fff721;
          }
        }
      }
    }
    .prev {
      position: absolute;
      left: 0;
      width: 10%;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .prevPic {
      width: 15px;
      height: 48px;
      margin: 0 auto;
    }
    .next {
      position: absolute;
      right: 0;
      width: 10%;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .legend {
      position: absolute;
      top: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #44f8ff;
      .miniDot {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #44f8ff;
        border-radius: 50%;
      }
      .yellowDot {
        margin-left: 20px;
        background: #fff721;
      }
      .yellow {
        color: #fff721;
        margin: 0 20px;
      }
    }
    .currentMaterial {
      text-align: center;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 34px;
      span{
        display: inline-block;
        width: 200px;
        line-height: 16px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .currentMaterial {
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    color: #ffffff;
    line-height: 42px;
  }
  .currentMaterial2 {
    text-align: center;
    font-size: 16px;
    height: 40px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    margin-left: -110px;
    color: #ffffff;
    line-height: 34px;
  }
  .frontInfo {
    position: absolute;
    width: 528px;
    height: calc(100% - 10px);
    right: 0;
    .cumulativeInfo {
      position: absolute;
      margin-top: 6px;
      width: 550px;
      height: 38%;
      background-image: url(../assets/img/cumulativePaving@2x.png);
      background-size: 100% 100%;
      .frontPic {
        position: absolute;
        bottom: 0px;
        left: -24px;
        width: 50px;
        height: 50px;
        border-radius: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: url(../assets/img/ring@2x.png);
        background-size: 100% 100%;
        .cumulativeRotate {
          position: absolute;
          left:0;
          width: 25px;
          height: 10px;
          transform-origin: right center;
          animation:cumulativeRotate 5s linear infinite;
          &::before {
          position: absolute;
          content: "";
          left:1px;
          width: 5px;
          height: 5px;
          border-radius: 5px;
          box-shadow: 0px 0px 3px #44e6ff;
          background-color: #44e6ff;
          }
        }
      }
      .layer {
        margin-top: 4px;
        margin-left: 60px;
        line-height: 20px;
        font-size: 15px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        span {
          display: inline-block;
          width: 400px;
          line-height: 16px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: #44f8ff;
        }
      }
      .height80 {
        line-height: 60px;
      }
    }
    .realTimeInfo {
      position: absolute;
      bottom: 0px;
      width: 678px;
      height: 54%;
      text-align: center;
      background-image: url(../assets/img/real-time@2x.png);
      background-size: 100% 100%;
      .realTimePic {
        position: absolute;
        top: -6px;
        left: -24px;
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        // background-image: url(../assets/img/ring@2x.png);
        background-size: 100% 100%;
        .realTimeRotate {
          width: 98%;
          height: 98%;
          animation:realTimeRotate 5s linear infinite;
        }
      }
      .realTimeCon {
        height: 80%;
        width: 80%;
        margin-top: 10px;
        padding-left: 5px;
        .overWidth {
          width: 200px;
        }
        .el-row {
          height: 100%;
          .el-col-8 {
            height: 100%;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            text-align: left;
            padding-left: 12px;
            .realTimePrefix {
              width: 30px;
              height: 30px;
              vertical-align: middle;
              margin-right: 10px;
              margin-left: 4px;
            }
            span {
              color: #fff721;
            }
            .pre {
              text-align: center;
              .Prefix {
                float: left;
                width: 38px;
                height: 50px;
                display: flex;
                // margin-top:10px;
                align-items: center;
                justify-content: center;
                background-image: url(../assets/img/data-rolle-frame@2x.png);
                background-size: 100% 100%;
              }
              .someInfo {
                margin-top: 10px;
                margin-left: 50px;
                width: 200px;
                text-align: left;
              }
            }
          }
        }
      }
    }
  }
  .swMargin {
    padding-top: 10px;
  }
  @keyframes realTimeRotate {
    from {
      transform:rotate(0deg)
    }
    to {
      transform:rotate(359deg)
    }
  }
  @keyframes cumulativeRotate {
    from {
      transform:rotate(0deg)
    }
    to {
      transform:rotate(359deg)
    }
  }
}
</style>
cumulativeRotate



// WEBPACK FOOTER //
// src/subassembly/survey.vue